import React from 'react';
import PropTypes from 'prop-types';

import { includes } from 'lodash';
import displayName from 'component-lib/displayName';

import TextLabel from '../Widgets/Labels/TextLabel';
import RetinaImage from '../RetinaImage';

import CellBase from './CellBase';

import arrowDownGray from './images/arrow-down-gray.png';
import arrowUpBlue from './images/arrow-up-blue.png';
import arrowDownBlue from './images/arrow-down-blue.png';

const sortKeys = {
    ASC: 'asc',
    DESC: 'desc',
    UNSORTED: 'unsorted',
};

export { sortKeys };

const { ASC, DESC, UNSORTED } = sortKeys;

const sortImages = {
    [ASC]: arrowDownBlue,
    [DESC]: arrowUpBlue,
    [UNSORTED]: arrowDownGray,
};

export default class SortCell extends CellBase {
    static displayName = displayName('TableView/SortCell');

    static sortKeys = sortKeys;

    static propTypes = {
        ...CellBase.propTypes,
        sortKey: PropTypes.oneOf([ASC, DESC, UNSORTED]),
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        sortableCell: PropTypes.bool,
    };

    static contextTypes = CellBase.contextTypes;

    static defaultProps = {
        ...CellBase.defaultProps,
        cellType: 'sort',
        sortKey: UNSORTED,
        sortableCell: true,
    };

    onCellClick = () => {
        if (this.props.sortableCell) {
            const { cellId, sortKey, onClick = () => {} } = this.props;
            const newSortDirection = includes([UNSORTED, DESC], sortKey) ? ASC : DESC;

            onClick(cellId, newSortDirection);
        }
    };

    get showColumnName() {
        const { uiroutes, cellId } = this.props;
        return !(uiroutes && cellId === 'status');
    }

    renderCell() {
        const { sortKey, text, sortableCell } = this.props;

        const sortClass = sortKey === ASC || sortKey === DESC ? 'sorted' : 'unsorted';

        return (
            <data className={sortClass} data-sort={sortKey} data-action="sort">
                {this.showColumnName && (
                    <>
                        <TextLabel>
                            {text}
                        </TextLabel>
                        {sortableCell && <RetinaImage image={sortImages[sortKey]} />}
                    </>
                )}
            </data>
        );
    }
}

Object.keys(sortKeys).forEach((key) => {
    SortCell[key] = sortKeys[key];
});
